import React from 'react';
import './KpiOverview.css';

import businessData from '../assets/data/business.json';

const KpiOverview = () => {
  // 从业务数据中提取 KPI
  const { radarMetrics } = businessData;
  
  const kpis = [
    { title: '福州市总体绩效得分', value: '87.5', change: '+2.3%' }, // 模拟主得分
    ...radarMetrics.map(item => ({
      title: item.metric,
      value: item.actual.toString(),
      change: (item.actual >= item.target ? '+' : '') + (item.actual - item.target).toString() + '%'
    }))
  ];

  return (
    <div className="kpi-overview">
      {kpis.map((kpi, index) => (
        <div key={index} className="kpi-card">
          <h3>{kpi.title}</h3>
          <div className="kpi-value">{kpi.value}</div>
          <div className="kpi-change">{kpi.change}</div>
        </div>
      ))}
    </div>
  );
};

export default KpiOverview;